export const powerColor = (kw) => {
  if (!kw) return "#6B7280";
  if (kw >= 250) return "#DC2626";
  if (kw >= 150) return "#EA580C";
  if (kw >= 100) return "#F59E0B";
  if (kw >= 50) return "#16A34A";
  return "#3B82F6";
};

export const POWER_LEGEND = [
  { label: "<50", color: "#3B82F6" },
  { label: "50+", color: "#16A34A" },
  { label: "100+", color: "#F59E0B" },
  { label: "150+", color: "#EA580C" },
  { label: "250+", color: "#DC2626" },
];
